import { Image } from "react-datocms";
import { IImage, IMedia } from "types/base";
import Paragraph from "components/elements/Paragraph";
import cn from "classnames";
import { IIntegrationCategory } from "pages/integrations";

export type IIntegrationsCard = {
    id: string,
    name: string,
    logo: IImage,
    slug?: string,
    tag?: string,
    description?: string,
    detailsContent?: {
        value: any,
        blocks: IMedia[]
    },
    price?: {
        id?: string,
        value?: number,
        currency?: string,
        priceInfo?: string,
    },
    relatedIntegrations?: IIntegrationsCard,
    rating?: string,
    category: IIntegrationCategory[],
};

type Props = {
    card: IIntegrationsCard;
    onClick?: () => void,
};

export default function IntegrationCard(props: Props) {
    const { card, onClick } = props;
    const transition = 'transition duration-500 ease-in-out';
    const hover = 'hover:border-purple-tint-dark hover:shadow-lg';

    const cardCn = cn(
        'grid grid-rows-2 shadow-lg border rounded-lg border-purple-tint px-4 md:px-8 py-4 cursor-pointer h-44 mb-4 sm:mb-0',
        transition,
        hover
    );

    return (
        <div
            key={card.id}
            className={cardCn}
            onClick={onClick ? onClick : null}
        >
            <Image
                data={card.logo.responsiveImage}
                pictureClassName={'lg:object-contain object-cover'}
                className={'w-16 h-16 lg:w-20 lg:h-20 mt-2 -ml-0.5 sm:-ml-0'}
            />

            <div className={'overflow-y-visible'}>
                <Paragraph size={'medium'} fontWeight={'medium'} color={'purple-dark'} className={'mt-10'}>
                    {card.name}
                </Paragraph>
            </div>
        </div>
    );
}

